<template>
  <div class="mj_page">
    <el-tabs v-model="activeName">
      <el-tab-pane class="pane_item" label="MJ绘画" name="mj">
        <mj v-if="activeName==='mj'"></mj>
      </el-tab-pane>
      <el-tab-pane class="pane_item" label="SD绘画" name="sd">
        <sd v-if="activeName==='sd'"></sd>
      </el-tab-pane>
<!--      <el-tab-pane class="pane_item" label="哪吒2" name="nezha">-->
<!--        <nezha v-if="activeName==='nezha'"></nezha>-->
<!--      </el-tab-pane>-->
      <el-tab-pane class="pane_item" label="DALL绘画" name="dall">
        <dall v-if="activeName==='dall'"></dall>
      </el-tab-pane>
<!--      <el-tab-pane label="Runway" name="runway">Runway</el-tab-pane>-->
<!--      <el-tab-pane label="Pika" name="pika">Pika</el-tab-pane>-->
<!--      <el-tab-pane label="Luma视频" name="luma">Luma视频</el-tab-pane>-->
    </el-tabs>
  </div>
</template>

<script>
import mj from "COMPONENTS/creation/mj.vue"
import dall from "COMPONENTS/DallCreation/dall.vue"
import sd from "COMPONENTS/SdCreation/sd.vue"
// import nezha from "COMPONENTS/NazheCreation/nezha.vue"

export default {
  components: {mj, sd, dall},
  data() {
    return {
      activeName: "mj"
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  created() {
    if (this.$route.query.active) {
      this.activeName = this.$route.query.active
    }

  },
  methods: {},
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mj_page {
  width: 100%;
  height: 100%;
  background: #313338;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-bottom: 45px;

  .el-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;

    :deep(.el-tabs__header) {
      margin-bottom: 0;

      .el-tabs__nav-scroll {
        display: flex;
        justify-content: center;
      }

      .el-tabs__nav-wrap:after {
        background-color: #555 !important;
      }

      .el-tabs__active-bar {
        background-color: #5865f2 !important;
      }

      .el-tabs__item {
        color: #fff;

        &.is-active {
          color: #5865f2 !important;
        }
      }
    }

    :deep(.el-tabs__content) {
      flex: 1;
    }
  }

  .pane_item {
    height: 100%;
  }
}
</style>